import { head } from 'lodash';

import { FlowNode, FlowTaskState } from '../flowState';
import { Task } from 'app/history/types';
import { getErrorForNode } from './FlowTypedTaskStateUtils';

const firstOutputOfSample = (value: Array<FlowTaskState> | {}) =>
  Array.isArray(value) ? head(value) || {} : value;

const sample = (node: FlowNode | void, taskState: FlowTaskState | Task) => {
  if (node && taskState) {
    const input = taskState.input || {};
    return {
      input: input[node.id],
      output: firstOutputOfSample((taskState.output || {})[node.id]),
      status: (taskState.statuses || {})[node.id],
      error: getErrorForNode(taskState, node.id),
    };
  } else {
    return {
      input: null,
      output: null,
      status: null,
      error: null,
    };
  }
};

export default sample;
